var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trophy",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a97730f7-1ac1-475a-a817-87f390514fe5{fill:#fac139;}.be636c29-bbdd-400c-966f-6588b5f1d1b7{fill:#ffdf40;}.e2c1da74-0262-4eb1-a163-1243efeea617{fill:#fad623;}.ad02c311-0c36-48d4-816b-ffc31cdcc73d{fill:#cb4849;}.a1b79ed8-18a1-4a13-a4de-3b513ab87fe5{fill:#7b2223;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ac72b09e-16ff-4973-ae48-72378ae1b6cb",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bd87d63b-8ef7-49d3-b35f-7ac91cc72dfa",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a97730f7-1ac1-475a-a817-87f390514fe5",
    d: "M29.08,46.27A31.92,31.92,0,0,1,0,14.5V8.7a8.7,8.7,0,0,1,17.4,0,2.9,2.9,0,0,0,2.9,2.9h6a2.9,2.9,0,0,1,0,5.8h-6a8.71,8.71,0,0,1-8.7-8.7,2.9,2.9,0,0,0-5.8,0v5.8a26.13,26.13,0,0,0,23.82,26,2.9,2.9,0,1,1-.54,5.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a97730f7-1ac1-475a-a817-87f390514fe5",
    d: "M67,43.65a2.9,2.9,0,0,1,2.62-3.16,26,26,0,0,0,23.63-26V8.7a2.9,2.9,0,0,0-5.8,0,8.71,8.71,0,0,1-8.7,8.7H72.9a2.9,2.9,0,0,1,0-5.8h5.8a2.9,2.9,0,0,0,2.9-2.9A8.7,8.7,0,0,1,99,8.7v5.8A31.75,31.75,0,0,1,70.11,46.27,2.91,2.91,0,0,1,67,43.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be636c29-bbdd-400c-966f-6588b5f1d1b7",
    d: "M72.9,0H26.3a2.9,2.9,0,0,0-2.9,2.9v29A26,26,0,0,0,40.8,56.43V78.7H58.2V56.43A26.23,26.23,0,0,0,75.8,31.9V2.9A2.9,2.9,0,0,0,72.9,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a97730f7-1ac1-475a-a817-87f390514fe5",
    d: "M58.2,56.43A26.23,26.23,0,0,0,75.8,31.9V2.9A2.9,2.9,0,0,0,72.9,0H49.5V78.7h8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a97730f7-1ac1-475a-a817-87f390514fe5",
    d: "M64.31,22.36a2.9,2.9,0,0,0-2.34-2l-6.82-1-3-6.18a3,3,0,0,0-5.2,0l-3,6.18-6.82,1a2.9,2.9,0,0,0-1.61,4.95l4.94,4.81-1.17,6.79A2.9,2.9,0,0,0,43.4,40l6.1-3.21L55.6,40a2.9,2.9,0,0,0,4.21-3.06l-1.17-6.79,4.94-4.81A2.91,2.91,0,0,0,64.31,22.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2c1da74-0262-4eb1-a163-1243efeea617",
    d: "M58.65,39.78a2.91,2.91,0,0,0,1.16-2.84l-1.17-6.79,4.94-4.81A2.9,2.9,0,0,0,62,20.39l-6.82-1-3-6.18a2.83,2.83,0,0,0-2.6-1.49V36.79L55.6,40A2.9,2.9,0,0,0,58.65,39.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad02c311-0c36-48d4-816b-ffc31cdcc73d",
    d: "M72.7,87.4H69.8V78.7a2.89,2.89,0,0,0-2.9-2.9H32.1a2.89,2.89,0,0,0-2.9,2.9v8.7H26.3a2.9,2.9,0,0,0-2.9,2.9v5.8A2.9,2.9,0,0,0,26.3,99H72.7a2.9,2.9,0,0,0,2.9-2.9V90.3A2.9,2.9,0,0,0,72.7,87.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a1b79ed8-18a1-4a13-a4de-3b513ab87fe5",
    d: "M75.6,96.1V90.3a2.9,2.9,0,0,0-2.9-2.9H69.8V78.7a2.89,2.89,0,0,0-2.9-2.9H49.5V99H72.7A2.9,2.9,0,0,0,75.6,96.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a1b79ed8-18a1-4a13-a4de-3b513ab87fe5",
    d: "M55.3,84.5H43.7a2.9,2.9,0,0,0,0,5.8H55.3a2.9,2.9,0,0,0,0-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad02c311-0c36-48d4-816b-ffc31cdcc73d",
    d: "M58.2,87.4a2.9,2.9,0,0,0-2.9-2.9H49.5v5.8h5.8A2.9,2.9,0,0,0,58.2,87.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.888da804fdb6fcb7a596eb0ea6c93762.svg";
export { ForwardRef as ReactComponent };